var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('text-highlight',{attrs:{"data-cy":"title-with-highlight","queries":_vm.highlightText,"highlightStyle":(_vm.style = 'padding:0;border-radius: 0')}},[_vm._v(" "+_vm._s(_vm.formattedTitle)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }